import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import { exportExcelADV } from 'services/getAdvExport';
const FilterMenuV2 = ({ children, openFilterMenu, setOpenFilterMenu }) => {
  const handleExportChiuse = async () => {
    try {

      const result = await exportExcelADV();

      const base64 = result.body;

      const binaryString = window.atob(base64);

      const bytes = Uint8Array.from(
        binaryString,
        c => c.charCodeAt(0)
      );

      const blob = new Blob(
        [bytes],
        {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      );
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'ADV_Pratiche_Chiuse.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Errore export excel:', error);
    }
  };

  return (
    <div>
      <Button onClick={() =>
        setOpenFilterMenu(true)
      }>Filtri</Button>
      {/* <Button
        onClick={handleExportChiuse}
      >
        Esporta Chiuse
      </Button> */}
      <ClickAwayListener
        mouseEvent="onMouseDown"
        touchEvent="onTouchStart"
        open={openFilterMenu}
        onClickAway={() => openFilterMenu && setOpenFilterMenu(false)}
      >
        <Drawer variant="persistent"
          anchor="left"
          open={openFilterMenu}
        >
          <Box sx={{ width: 500 }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}>
              <IconButton onClick={() => setOpenFilterMenu(false)}>
                {openFilterMenu ? <ChevronLeftIcon /> : <ChevronRightIcon />}
              </IconButton>
            </div>
            <Divider />
            <Typography variant="h1" gutterBottom align="center">
              Filtri
            </Typography>
            {children}
          </Box>
        </Drawer>
      </ClickAwayListener>
    </div >
  );
}

export default FilterMenuV2;